import { render, staticRenderFns } from "./operationPromotionStorePromotionTwo.vue?vue&type=template&id=66a46850&scoped=true"
import script from "./operationPromotionStorePromotionTwo.vue?vue&type=script&lang=js"
export * from "./operationPromotionStorePromotionTwo.vue?vue&type=script&lang=js"
import style0 from "./operationPromotionStorePromotionTwo.vue?vue&type=style&index=0&id=66a46850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a46850",
  null
  
)

export default component.exports